export default __webpack_public_path__ + "static/media/specc_logotype.d78295d9.svg";